import { enumObjClassNames } from "../constants";
import { QXDoc } from "../CoreApp/QChartTemplateRule";
import { QObjDBFieldDef } from "../CoreApp/QObjDBFieldDef";

export function GetFieldDefBy(
  doc: QXDoc,
  targetVal: string,
  byName: boolean,
  isPosition = false
): Nullable<QObjDBFieldDef> {
  //TODO: scope
  const objClass = doc
    ?.GetObjDB()
    ?.GetClassByName(isPosition ? enumObjClassNames.position : enumObjClassNames.box);

  var fieldList = doc.GetFieldList2(true, true, false, false, false, true, objClass);
  var nFields = fieldList.length;

  for (var i = 0; i < nFields; i++) {
    var fieldDef = fieldList[i];
    var fieldMatcher;
    if (byName) fieldMatcher = fieldDef.GetFieldDisplayName();
    else fieldMatcher = fieldDef.GetFieldID();

    if (fieldMatcher == targetVal) return fieldDef;
  }

  return null;
}
